var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

/* globals i18n */
var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");
var EditorJsonify = require("../mixins/editor-jsonify.jsx");

var InfoTip = require("../components/info-tip.jsx");
var NumberInput = require("../components/number-input.jsx");

var maxTrials = 5000;

var SimulatorEditor = React.createClass({
    displayName: "SimulatorEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        xAxisLabel: React.PropTypes.string,
        yAxisLabel: React.PropTypes.string,
        numTrials: React.PropTypes.number,
        proportionLabel: React.PropTypes.string,
        proportionOrPercentage: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            xAxisLabel: "Proportion (%)",
            yAxisLabel: "Number of times seen",
            numTrials: 100,
            proportionLabel: "Underlying proportion",
            proportionOrPercentage: "proportion"
        };
    },

    render: function render() {
        return React.createElement(
            "div",
            { className: "perseus-widget-simulator" },
            React.createElement(
                "div",
                null,
                i18n._("X-Axis Label"),
                ":",
                React.createElement("input", {
                    type: "text",
                    className: "graph-settings-axis-label",
                    value: this.props.xAxisLabel,
                    onChange: _.partial(this.handleTargetValueChange, "xAxisLabel")
                })
            ),
            React.createElement(
                "div",
                null,
                i18n._("Y-Axis Label"),
                ":",
                React.createElement("input", {
                    type: "text",
                    className: "graph-settings-axis-label",
                    value: this.props.yAxisLabel,
                    onChange: _.partial(this.handleTargetValueChange, "yAxisLabel")
                })
            ),
            React.createElement(
                "div",
                null,
                i18n._('"True Proportion" Label'),
                ":",
                React.createElement("input", {
                    type: "text",
                    className: "graph-settings-axis-label",
                    value: this.props.proportionLabel,
                    onChange: _.partial(this.handleTargetValueChange, "proportionLabel")
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "This text will be displayed next to the box in which the user enters the sample proportion for their simulation. For example, if your question is about surveying for approval ratings, you might want this to say \"Sample approval rating\"."
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                i18n._("Proportion or Percentage"),
                ":",
                React.createElement(
                    "select",
                    {
                        className: "perseus-widget-dropdown",
                        value: this.props.proportionOrPercentage,
                        onChange: _.partial(this.handleTargetValueChange, "proportionOrPercentage")
                    },
                    React.createElement(
                        "option",
                        { key: "proportion", value: "proportion" },
                        "Proportion"
                    ),
                    React.createElement(
                        "option",
                        { key: "percentage", value: "percentage" },
                        "Percentage"
                    )
                ),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "Do you want the user to describe their simulation in terms of a proportion or a percentage?"
                    )
                )
            ),
            React.createElement(
                "div",
                null,
                i18n._("Number of trials"),
                ":",
                React.createElement(NumberInput, {
                    value: this.props.numTrials,
                    checkValidity: function checkValidity(val) {
                        return val >= 0 && val <= maxTrials;
                    },
                    onChange: this.change("numTrials")
                }),
                React.createElement(
                    InfoTip,
                    null,
                    React.createElement(
                        "p",
                        null,
                        "This controls the number of trials used in the simulation. For example, if you set this to 50, then the survey will be conducted 50 times. Warning: setting this too high (i.e., greater than 5000 or so) will freeze the page."
                    )
                )
            )
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    handleTargetValueChange: function handleTargetValueChange(propName, e) {
        this.change(propName, e.target.value);
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = SimulatorEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/simulator-editor.jsx
 ** module id = 147
 ** module chunks = 0 1
 **/